export const CUSTOM_HEADER_HEIGHT = 50
export const CUSTOM_HEADER_WIDTH = 1010
